import Carousel from "react-multi-carousel";

const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        }
    };
    
    export const CastSection = (props) => {
    const headline = props.headline || "Cast replay to tablet or laptop";
    const subHeading = props.subHeading;
    const images = props.images || [];
    return (<section className="atf-section-padding" style={{background: 'url(./assets/img/smokebg_white_light_compressed.jpg)', backgroundRepeat: 'no-repeat'}}>
                  <div className="container">
                      <div className="row justify-content-center clearfix">
                          <div className="col-lg-6 col-12 text-center align-self-center">
                              <div>
                                  <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>{headline}</h2>
                                  <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "15px 0 0px 0"  }}>{subHeading}</p>
                              </div>
                          </div>
                          <div className="col-lg-6 col-12 text-center">
                            {images.length === 1 ? <img src={images[0].src} alt={images[0].alt} style={{marginTop: '30px'}} /> :
                            <Carousel
                                    swipeable={true}
                                    draggable={true}
                                    showDots={true}
                                    responsive={responsive}
                                    infinite={true}
                                    autoPlay={true}
                                    autoPlaySpeed={2500}
                                    keyBoardControl={true}
                                    customTransition="transform 300ms ease-in-out"
                                    transitionDuration={500}
                                    containerClass="carousel-container"
                                    dotListClass="custom-dot-list-style"
                                    itemClass="carousel-item-padding-40-px"
                                >
                                    {images.map((image, index) => (
                                        <img key={index} src={image.src} alt={image.alt} style={{marginTop: '30px'}} />
                                    ))}
                                </Carousel>
                            }  
                          </div>
                      </div>
                  </div>
              </section>
    
    );
}

export default CastSection;